import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  AllOverridesList: [],
  getPromptOverridesById: {},
  getAllConditions: [],
  getAllPromptScreenOverride: [],
};

const promptoverridesSlice = createSlice({
  name: 'promptoverridesSlice',
  initialState,
  reducers: {
    getAllOverridesListSlice: (state, { payload }) => {
      state.AllOverridesList = payload;
    },
    getPromptOverridesByIdSlice: (state, { payload }) => {
      state.getPromptOverridesById = payload;
    },
    getAllConditionsOverrideSlice: (state, { payload }) => {
      state.getAllConditions = payload;
    },
    getAllPromptScreenOverrideSlice: (state, { payload }) => {
      state.getAllPromptScreenOverride = payload;
    },
  },
});

const { actions, reducer } = promptoverridesSlice;

export const {
  getAllOverridesListSlice,
  getPromptOverridesByIdSlice,
  getAllConditionsOverrideSlice,
  getAllPromptScreenOverrideSlice,
} = actions;

export default reducer;
